import React from 'react';
import {connect} from "react-redux";
import CustomPaper from '../../../shared/utils/CustomPaper';
import AuthService from '../../../../services/AuthService';
import TextField from "material-ui/TextField";
import TitleMedium from "../../../shared/utils/TitleMedium";
import Alert from "../../../shared/utils/Alert";
import StarRatingComponent from "react-star-rating-component";


class BibliothequeDesCompetences extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            salariesHavingCompetence: [],
            salariesHavingCompetenceRated: [],
            filter: '',
            selectedCompetence: null
        };
        this.Auth = new AuthService();
        this.fetchBibliotheque = this.fetchBibliotheque.bind(this);
        this.fetchCompetence = this.fetchCompetence.bind(this);
    }

    componentDidMount() {
        this.fetchBibliotheque();
    }

    fetchBibliotheque() {
        this.Auth.fetch('/societe/competences/all')
            .then(x => this.setState({data: x.data.payload}));
    }

    fetchCompetence(competence) {
        this.setState({selectedCompetence: competence},
            () =>
                this.Auth.fetch('/societe/competence/relative', {method: 'POST', data: {competence: competence}})
                    .then(x => this.setState({
                        salariesHavingCompetence: x.data.payload.salariesHavingCompetence,
                        salariesHavingCompetenceRated: x.data.payload.salariesHavingCompetenceRated
                    }))
        );
    }

    render() {
        const filteredCompetenceList = this.state.data
            .filter(c => c.competence.toUpperCase().indexOf(this.state.filter.toUpperCase()) > -1);
        return (
            <div className="row">
                <div
                    className={this.state.selectedCompetence ? 'col-7' : 'col'}>
                    <CustomPaper title={"Bibliothèque des compétences"}>
                        <TextField
                            value={this.state.filter}
                            onChange={(x, y, z) => this.setState({filter: y})}
                            name='filter'
                            fullWidth={true}
                            type="text"
                            floatingLabelText="Filtrer par compétence"
                        />
                        <span className="badge badge-primary">{filteredCompetenceList.length} Compétances</span>
                        <ul className="scrollableUL">
                            {
                                filteredCompetenceList.map(c =>
                                    <li key={c.competence}>{c.competence}
                                        <a
                                            style={{color: "blue", marginLeft: 10, cursor: "pointer"}}
                                            className="no-print"
                                            onClick={() => this.fetchCompetence(c.competence)}
                                        >
                                            Détailler
                                        </a>
                                    </li>
                                )
                            }
                        </ul>
                    </CustomPaper>
                </div>
                {
                    this.state.selectedCompetence
                    &&
                    <div className="col-5" style={{position: 'fixed', right: 0}}>

                        <CustomPaper title={"Détails de la compétence"}>
                            <div className="row" style={{marginBottom: 25}}>
                                <div className="col-10">{this.state.selectedCompetence}</div>
                                <a
                                    style={{color: 'red'}}
                                    onClick={() => this.setState({selectedCompetence: null})}
                                    className="col-2"
                                >Fermer
                                </a>
                            </div>

                            <TitleMedium title="Salariés concernés par cette compétence"/>
                            <ul style={{marginTop: 20}}>
                                {
                                    this.state.salariesHavingCompetence.map(e =>
                                        <li key={e.num_salarie}>{`${e.nom} - ${e.prenom}`}</li>)
                                }
                            </ul>

                            <TitleMedium title="Niveaux de maitrise de cette compétence par les salariés"/>
                            {
                                this.state.salariesHavingCompetenceRated.length > 0 ?
                                    <div style={{marginTop: 20}}>
                                        {
                                            this.state.salariesHavingCompetenceRated.map(e =>
                                                <div key={e.id}>
                                                    <span
                                                        style={{
                                                            verticalAlign: 'top',
                                                            marginRight: 10
                                                        }}>{`${e.nom} - ${e.prenom}`}
                                                    </span>
                                                    <StarRatingComponent
                                                        name='rating'
                                                        editing={false}
                                                        value={Number(e.niveau)}
                                                    />
                                                </div>)
                                        }
                                    </div>


                                    : <Alert type="warning"
                                             text="Aucun salarié n'a renseigné son niveau de maitrise de cette compétance"/>
                            }
                        </CustomPaper>

                    </div>
                }
            </div>

        );
    }
}

function mapStateToProps(store) {
    return {
        entrepriseInfos: store.entreprise.entreprise_infos
    }
}

export default connect(mapStateToProps)(BibliothequeDesCompetences);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entreprise/BibliothequeDesCompetences.js